import { detail, list, utils } from "@mc/mc-legacy";
import UserProfileApi from "../api/gen/core/UserProfileApi";
export const USER_PROFILE_DETAIL_AREA = "userProfileDetail";
export const USER_PROFILE_EXTERNAL_DETAIL_AREA = "userProfileExternalDetail";
export const USER_PROFILE_LOGIN_LIST_AREA = "userProfileLoginList";
export const USER_PROFILE_SUBJEKT_DETAIL_AREA = "userProfileSubjektList";
export const USER_PROFILE_SUBJEKT_EXTERNAL_LIST_AREA = "userProfileSubjektExternalList";
export function fetchUserProfileDetailIfNeeded(key) {
  return (dispatch) => {
    dispatch(
      detail.DetailActions.fetchIfNeeded(USER_PROFILE_DETAIL_AREA, key, (key) => {
        return UserProfileApi.getUserProfile(key);
      })
    );
  };
}
export function invalidateUserProfileDetail() {
  return (dispatch, getState) => {
    const store = utils.storeFromArea(getState(), USER_PROFILE_DETAIL_AREA);
    dispatch(detail.DetailActions.invalidate(USER_PROFILE_DETAIL_AREA, store.id));
  };
}
export function setUserProfileExternalDetail(key, data) {
  return (dispatch) => {
    dispatch(detail.DetailActions.setData(USER_PROFILE_EXTERNAL_DETAIL_AREA, key, data));
  };
}
export function fetchLoginListIfNeeded(key) {
  return (dispatch) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(USER_PROFILE_LOGIN_LIST_AREA, key, (key) => {
        return UserProfileApi.getLoginList(key);
      })
    );
  };
}
export function fetchSubjektListIfNeeded(key) {
  return (dispatch) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(USER_PROFILE_SUBJEKT_DETAIL_AREA, key, (key) => {
        return UserProfileApi.getSubjektList(key);
      })
    );
  };
}
export function setSubjektListExternal(key, data) {
  return (dispatch) => {
    dispatch(list.SimpleListActions.setData(USER_PROFILE_SUBJEKT_EXTERNAL_LIST_AREA, key, data));
  };
}
